import { useState, useRef } from "react";

export function useTooltip() {
  const [tooltipState, setTooltipState] = useState({
    visible: false,
    trackId: null,
    origin: null,
    position: {},
    isPinned: false,
  });
  const closeTimeoutRef = useRef(null);

  const calculateTooltipPosition = (rect) => {
    const tooltipWidth = window.innerWidth < 600 ? window.innerWidth - 32 : 400;
    const tooltipHeight = 200;
    const padding = 16;
    const offset = 10;

    let top = rect.bottom + offset;
    let left = rect.left;

    if (window.innerWidth < 600) {
      left = padding;
    } else {
      if (left + tooltipWidth > window.innerWidth - padding) {
        left = window.innerWidth - tooltipWidth - padding;
      }
      if (left < padding) {
        left = padding;
      }
    }

    if (rect.bottom + tooltipHeight > window.innerHeight - padding) {
      top = rect.top - tooltipHeight - offset / 2;
      if (top < padding) {
        top = padding;
      }
    }

    return {
      top: `${top}px`,
      left: `${left}px`,
    };
  };

  const handleInfoClick = (trackId, origin, event) => {
    event.preventDefault();
    event.stopPropagation();

    const rect = event.currentTarget.getBoundingClientRect();
    const position = calculateTooltipPosition(rect);

    setTooltipState({
      visible: true,
      trackId,
      origin,
      position,
      isPinned: true,
    });
  };

  const handleInfoHover = (
    trackId,
    origin,
    event,
    isEnter,
    isClick = false
  ) => {
    if (isClick) {
      handleInfoClick(trackId, origin, event);
      return;
    }

    const isTouch = "ontouchstart" in window;
    if (isTouch) return;

    if (isEnter) {
      if (closeTimeoutRef.current) {
        clearTimeout(closeTimeoutRef.current);
        closeTimeoutRef.current = null;
      }

      if (tooltipState.isPinned && tooltipState.trackId !== trackId) {
        setTooltipState({
          visible: false,
          trackId: null,
          origin: null,
          position: {},
          isPinned: false,
        });
        return;
      }

      if (tooltipState.isPinned && tooltipState.trackId === trackId) {
        return;
      }

      const rect = event.currentTarget.getBoundingClientRect();
      const position = calculateTooltipPosition(rect);

      setTooltipState({
        visible: true,
        trackId,
        origin,
        position,
        isPinned: false,
      });
    } else {
      if (!tooltipState.isPinned) {
        closeTimeoutRef.current = setTimeout(() => {
          setTooltipState((currentState) => {
            if (!currentState.isPinned) {
              return {
                visible: false,
                trackId: null,
                origin: null,
                position: {},
                isPinned: false,
              };
            }
            return currentState;
          });
          closeTimeoutRef.current = null;
        }, 200);
      } else {
      }
    }
  };

  const closeTooltip = () => {
    setTooltipState({
      visible: false,
      trackId: null,
      origin: null,
      position: {},
      isPinned: false,
    });
  };

  return {
    tooltipState,
    handleInfoHover,
    closeTooltip,
  };
}
